export default __webpack_public_path__ + "1609977160e41e13cdbd91320d01a650.png";